import React from "react";
import Check from "../img/check";

export default () => (
  <div className="fav__box-content">
    <Check />
    <span>Linkki kopioitu leikepöydälle!</span>
  </div>
);
